import Vue from 'vue'

// v-focus - seta foco no elemento input
Vue.directive('focus', {
    inserted: function (el) {
      el.focus()
    }
})
